// extracted by mini-css-extract-plugin
module.exports = {"title":"_10SUa","button":"_3y7Nd","form":"_3J2I5","input":"_2Uy4z","message":"_2peGK","select":"_1bZZO"};